import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import PostLoginGetApi from '../../../../components/Api/PostLoginGetApi';
import PostLoginPostApi from '../../../../components/Api/PostLoginPostApi';
import Button from '../../../../components/Button';
import UserBasicInfoContext from '../../../../components/Context/UserBasicInfoContext';
import init from '../../AccessControl/Check';


export default function EditAccess() {
    const pageName = "Access Update";
    const isAccess = init(pageName);

    const profile = useContext(UserBasicInfoContext);

    const navigate = useNavigate();
    const params = useParams();


    const [roleDetails, setRoleDetails] = useState("");

    useEffect(() => {
        if (params?.id === "" || isNaN(params?.id) === true) {
            // Redirect to lists
            return;
        }

        // Check
        const id = params?.id;
        PostLoginGetApi("manage/role/" + id, "", 3).then((responseJSON) => {

            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {

                    if (responseData.data.is_default === 1) {
                        toast.error("You are not allowed to edit default role access.");
                        navigate("/dashboard/role");
                        return;
                    }


                    if (profile?.id > 0) {
                        if (responseData.data.created_by !== profile?.id) {
                            toast.error("You are not allowed to edit this role access.");
                            navigate("/dashboard/role");
                            return;
                        }
                    }


                    setRoleDetails(responseData.data);
                    return;
                }


                toast.error(responseData["messages"].toString() ?? responseData["message"].toString() + "");
                navigate("/dashboard/role");
                return;
            }

            navigate("/dashboard/role");
            return;

        }).catch((error) => {
            console.log(error);
        });

    }, [navigate, params, profile]);


    // All Permission lists
    const [allPermissionsGroup, setAllPermissionsGroup] = useState([]);
    const [allPermissions, setAllPermissions] = useState([]);
    useEffect(() => {
        if (isNaN(roleDetails.id) === true) {
            return;
        }

        PostLoginGetApi("manage/permission", "", 3).then((responseJSON) => {

            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setAllPermissionsGroup(Object.keys(responseData.data));
                    setAllPermissions(responseData.data);
                    return;
                }
            }
        }).catch((error) => {
            console.log(error);
        });

    }, [roleDetails]);


    // Currently Owned Company
    const [ownedCompany, setOwnedCompany] = useState([]);
    useEffect(() => {
        PostLoginGetApi("company/lists/switch").then((responseJSON) => {

            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setOwnedCompany(responseData.data);
                    return;
                }
            }
        }).catch((error) => {
            console.log(error);
        });
    }, []);




    const [reqParam, setReqParam] = useState({
        role_id: "",
        permissions: [],
        company: []
    });


    // Permission lists based on Role Id
    const [permissions, setPermissions] = useState([]);
    const [companyAccess, setCompanyAccess] = useState([]);

    useEffect(() => {
        if (isNaN(roleDetails.id) === true) {
            return;
        }



        PostLoginGetApi("permission/" + roleDetails.id + "/has-roles", "", 3).then((responseJSON) => {

            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {

                    console.log("A...");
                    setPermissions(responseData.data[0]);
                    setCompanyAccess(responseData.data[1]);

                    setReqParam({
                        ...reqParam,
                        role_id: roleDetails.id,
                        permissions: responseData.data[0],
                        company: responseData.data[1]
                    });
                    return;
                }
            }
        }).catch((error) => {
            console.log(error);
        });

    }, [roleDetails]);


    function isPermissionExists(name) {
        if (permissions.includes(name)) {
            return 1;
        }

        return 0;
    }

    function isCompanyExists(id) {
        if (companyAccess.includes(id)) {
            return 1;
        }

        return 0;
    }

    const submitData = () => {
        PostLoginPostApi("update/permission-to-role", JSON.stringify(reqParam), 3).then((responseJSON) => {

            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    toast.success("Role access has been updated");
                    return navigate("/dashboard/role/access/" + roleDetails.id);
                }

                toast.error(responseData.messages ?? responseData.message ?? "A problem occur. Please try again.");
            }
        }).catch((error) => {
            console.log(error);
        });
    }


    const handleRadioButton = (e) => {
        let arr = reqParam.permissions;
        const name = e.value;

        if (e.checked === true) {
            arr.push(name);
        }
        else {
            arr.pop(name);
        }

        setReqParam({
            ...reqParam,
            permissions: arr
        });
    }


    const handleRadioButton2 = (e) => {
        let arr = reqParam.company;
        const name = e.value;

        if (e.checked === true) {
            arr.push(name);
        }
        else {
            arr.pop(name);
        }

        setReqParam({
            ...reqParam,
            company: arr
        });
    }

    if (isAccess === false) {
        return (<>
            <table className="custom-details-table w-full mt-0 mb-2">
                <tbody>
                    <tr>
                        <td className="font-semibold text-base">
                            You do not have any access !
                        </td>
                    </tr>
                </tbody>
            </table>
        </>);
    }


    return (
        <div className='custom-container w-full float-left px-8 py-10 pt-4 block font-montserrat custom-scroll-auto mb-20'>

            <div className="custom-container w-full font-montserrat flex">

                <div className="custom-container-left float-left custom-scroll-auto w-full pr-3 pb-20 text-justify" style={{ boxShadow: "3px 0 0px 0px rgb(0 0 0 / 1%)" }}>

                    <div className="text-justify rounded-[5px] py-3 pt-0">
                        <div className="w-1/2 float-left">
                            <h6 className="text-xl px-4 font-medium pb-0 pl-0 pt-4 mb-5">Edit your role access</h6>
                        </div>


                        <div className="h-[68px] float-right text-right justify-end flex items-center">
                            <Link to={"/dashboard/role"} className="custom-btn text-center">Back to role list</Link>
                        </div>

                    </div>


                    {(roleDetails.length === 0) ? "Loading..." :

                        <>
                            <table className="custom-details-table w-full mt-0 mb-2">
                                <tbody>
                                    <tr>
                                        <td className="font-semibold text-base">Role Name</td>
                                        <td className="px-5 text-base">
                                            <p>{roleDetails.name}</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="font-semibold text-base">Code</td>
                                        <td className="px-5 text-base">
                                            <p>{roleDetails.code}</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>


                            <table className="custom-details-table w-full mt-0 mb-2">
                                <tbody>
                                    <tr>
                                        <td className="font-semibold text-base" colSpan={2}>Company Access</td>
                                    </tr>
                                </tbody>
                            </table>

                            {/* Company */}
                            <div className='flow-root'>
                                {(ownedCompany?.length > 0) &&
                                    ownedCompany.map((data, index) => (
                                        <label key={index} className="w-[24%] flex align-middle cursor-pointer content-center float-left border border-gray-200 rounded-md px-4 py-3 m-1 hover:bg-gray-100">
                                            {isCompanyExists(data.id) === 1 ?
                                                <input type='checkbox' defaultChecked={true} value={data.id}
                                                    onClick={(event) => handleRadioButton2(event.currentTarget)} className='mr-2 mt-1' />
                                                :
                                                <input type='checkbox' value={data.id}
                                                    onClick={(event) => handleRadioButton2(event.currentTarget)} className='mr-2 mt-1' />
                                            }
                                            {data.name}
                                        </label>
                                    ))
                                }
                            </div>



                            <table className="custom-details-table w-full mt-3 mb-2">
                                <tbody>
                                    <tr>
                                        <td className="font-semibold text-base" colSpan={2}>Page Access / Control</td>
                                    </tr>

                                </tbody>
                            </table>

                            {/* Permission */}
                            <div className='flow-root'>
                                {(allPermissionsGroup?.length > 0) &&
                                    allPermissionsGroup.map((data, index) => (
                                        <div key={index}>

                                            <p className='font-semibold'>
                                                {data}
                                            </p>

                                            <div className='flow-root w-full my-1'>
                                                {allPermissions[data.toString()].map((data2, index2) =>
                                                    <span key={index2} >

                                                        <label className="w-[24%] m-2 cursor-pointer content-center float-left border border-gray-200 rounded-md px-4 py-3 hover:bg-gray-100">
                                                            {isPermissionExists(data2.name) === 1 ?
                                                                <input type='checkbox' defaultChecked={true} value={data2.name}
                                                                    onClick={(event) => handleRadioButton(event.currentTarget)} className='mr-2 -mt-0.5' />
                                                                :
                                                                <input type='checkbox' value={data2.name}
                                                                    onClick={(event) => handleRadioButton(event.currentTarget)} className='mr-2 -mt-0.5' />
                                                            }
                                                            {data2.name}
                                                        </label>



                                                    </span>
                                                )}
                                            </div>

                                        </div>
                                    ))



                                }
                            </div>


                        </>

                    }



                    {(roleDetails.is_default === 0) &&
                        <div className='flow-root pt-5 max-w-[150px]'>
                            <Button name='Update' onClick={submitData} type='button' />
                        </div>
                    }


                </div>
            </div>

            <style>{`
                [type='checkbox'], [type='radio'] {
                    color: #00d632;
                }
            `}</style>

        </div>
    )
}
